import script from "./scanedTeacherAttendence.vue?vue&type=script&setup=true&lang=js"
export * from "./scanedTeacherAttendence.vue?vue&type=script&setup=true&lang=js"

import "./scanedTeacherAttendence.vue?vue&type=style&index=0&id=33c7a21c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c7a21c"]])

export default __exports__